module.exports = __webpack_public_path__ + "img/经费保障.84ae57fd.png";